var components
try {
  components = {
    uButton: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-button/u-button" */ "uview-ui/components/u-button/u-button.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var g0 =
    _vm.info &&
    _vm.info.outpatientFileList.concat(
      _vm.info.hospitalFileList,
      _vm.info.disabilityFileList
    ).length > 0
  var l0 = g0
    ? []
        .concat(_vm.info.outpatientFileList)
        .concat(_vm.info.hospitalFileList)
        .concat(_vm.info.disabilityFileList)
    : null
  var l1 =
    _vm.info && _vm.info.settleClaimsLogList
      ? _vm.__map(_vm.info.settleClaimsLogList, function (item, index) {
          var $orig = _vm.__get_orig(item)
          var g1 = _vm.info.settleClaimsLogList.length
          var g2 = _vm.info.settleClaimsLogList.length
          var g3 = item.content ? _vm.info.settleClaimsLogList.length : null
          return {
            $orig: $orig,
            g1: g1,
            g2: g2,
            g3: g3,
          }
        })
      : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        g0: g0,
        l0: l0,
        l1: l1,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }